<template>
  <div
    v-if="warnings.length"
    class="mx-4 mt-3 rounded-xl border border-amber-600/50 bg-amber-950/60 p-3.5"
    role="alert"
  >
    <div class="flex items-start gap-2.5 mb-2">
      <MdiAlertOutline class="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
      <div class="flex-1">
        <div class="text-sm font-semibold text-amber-300">{{ $t('availability.warningTitle') }}</div>
        <div class="text-xs text-amber-400/80 mt-0.5">
          {{ warnings.length === 1 ? $t('availability.warningBodySingle') : $t('availability.warningBodyMultiple') }}
        </div>
      </div>
      <button
        class="shrink-0 text-amber-500 hover:text-amber-300 bg-transparent border-none cursor-pointer p-0.5"
        :title="$t('common.dismiss')"
        @click="$emit('dismiss')"
      >
        <MdiClose class="w-4 h-4" />
      </button>
    </div>

    <ul class="flex flex-col gap-1.5 pl-1">
      <li
        v-for="w in warnings"
        :key="w.instanceId"
        class="flex items-center gap-2 text-xs"
      >
        <span class="w-1.5 h-1.5 rounded-full bg-amber-400 shrink-0" />
        <span class="text-amber-200 font-medium">{{ w.name }}</span>
        <span v-if="w.checkedOutBy" class="text-amber-500">
          {{ $t('availability.checkedOutBy', { name: w.checkedOutBy }) }}
          <span v-if="w.projectName"> <em>{{ $t('availability.checkedOutByProject', { project: w.projectName }) }}</em></span>
        </span>
        <span v-else class="text-amber-500">{{ $t('availability.currentlyCheckedOut') }}</span>
        <router-link
          :to="`/instance/${w.instanceId}`"
          class="ml-auto text-amber-400 hover:text-amber-200 no-underline whitespace-nowrap hover:underline"
        >
          {{ $t('availability.seeDetails') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script setup>
import MdiAlertOutline from '~icons/mdi/alert-outline'
import MdiClose from '~icons/mdi/close'

defineProps({
  warnings: {
    type: Array,
    default: () => [],
    // Each: { instanceId, name, checkedOutBy?, projectName? }
  },
})

defineEmits(['dismiss'])
</script>
